<template>
  <modal
    v-if="collectionOrId"
    :id="modalIdSave"
    :title="$i18n.t('saved_searches')"
    :show-header="true"
    class="details-modal modal-md"
  >
    <saved-filter @load-list-filter="loadFilter" />
  </modal>
</template>

<script>
import Modal from '../../modal/Modal'
import SavedFilter from '../../saved-filter/SavedFilter'
import EventBus from '../../../utils/event-bus'
import { mapActions } from 'vuex'

export default {
  name: 'SavedSearchModal',
  components: {
    Modal,
    SavedFilter,
  },
  computed: {
    collectionOrId() {
      return this.$get('collectionOrId')
    },
    currentParameters() {
      return this.$get('currentParameters')
    },
    modalIdSave() {
      return `list-modal-save-${this.collectionOrId}`
    },
    mongoId() {
      return this.$get('mongoId')
    },
    id() {
      return this.$get('id')
    },
    panelId() {
      return this.$get('panelId')
    },
    searchParams() {
      return this.$get('searchParams')
    },
  },
  methods: {
    ...mapActions(['hideModal']),
    loadFilter({ params }) {
      this.$dispatch('setSearchParams', { params })
      EventBus.$emit(`apply-filter-${this.id}`, {
        id: this.id,
        type: 'saved-filter',
      })
      this.hideModal(this.modalIdSave)
    },
  },
}
</script>
